import { HtmlParser } from '@calendly/html-parser'
import { Banner } from '@calendly/ui/components/banner'

import { UpgradeLink } from '../../upgrade_link'

export const UpgradeBanner = ({ bannerCopy, containerId }) => (
  <Banner data-testid={containerId}>
    {HtmlParser(bannerCopy, { 'Upgrade.Link': UpgradeLink })}
  </Banner>
)
